export default __webpack_public_path__ + "media/images/mailer-new/heading/mention-9abcfe01a67e1329f6c58dc54ad053fa.png";